import * as tslib_1 from "tslib";
import * as moment from 'moment-timezone';
import { Type } from 'class-transformer';
import { UserNameDisplayResultDto } from '../../_models/user-name-display-result-dto';
const ɵ0 = () => Date, ɵ1 = () => UserNameDisplayResultDto, ɵ2 = () => Date, ɵ3 = () => Date;
export class AlertResultDto {
    get endDate() {
        if (this.expireAfterDays !== 99999) {
            return moment(this.effectiveDate).add(this.expireAfterDays, 'days').toDate();
        }
        return null;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Date)
], AlertResultDto.prototype, "createdOn", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", UserNameDisplayResultDto)
], AlertResultDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Date)
], AlertResultDto.prototype, "effectiveDate", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Date)
], AlertResultDto.prototype, "modifiedOn", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3 };
